module.exports = __webpack_public_path__ + "img/magnifier_black.cf3d2e70.svg";